import axios from "axios";
import { getEncodedHeader } from "./utility";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASEURL,
});

instance.interceptors.request.use((config) => {
  const apiToken = localStorage.getItem("token");
  let md5query = {
    deviceId: "",
    deviceType: "web",
    currentTime: new Date().getTime(),
  };

  let randomNo = Math.floor(1000 + Math.random() * 100000000);
  if (
    localStorage.getItem("deviceId") === null ||
    localStorage.getItem("deviceId") === ""
  ) {
    localStorage.setItem("deviceId", randomNo);
  }
  md5query.deviceId = localStorage.getItem("deviceId");

  const queryString = new URLSearchParams(md5query).toString();

  config.url = `${config.url}?${queryString}`;
  config.headers = {
    authorization: "Bearer " + apiToken,
    "x-value": getEncodedHeader(
      config.data,
      { ...md5query, ...config.params },
      config.method
    ),
  }; // add apiTOken
  return config;
});

instance.interceptors.response.use(
  (response) => {
    if (response.status === 401) {
      console.log("You are not authorized");
      // TOAST MESSAGE
    }
    if (response.status >= 500) {
      // TOAST MESSAGE
    }
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      window.location.href = "/auth/login";
    }

    if (error.response && error.response.data) {
      return Promise.reject(error.response.data);
    }
    return Promise.reject(error.message);
  }
);

export const http = instance;
